import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { Suspense, type ComponentPropsWithoutRef } from "react";

import { PreviewLoadingFallback } from "./PreviewLoadingFallback";

const PreviewScreen = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "VideoClipPreviewScreen" */ "./PreviewScreen"
  ).then(module => ({ default: module.PreviewScreen })),
);

type LazyPreviewScreenProps = ComponentPropsWithoutRef<typeof PreviewScreen>;

/** Keeps media-chrome / MediaPlayer off the initial shell graph. */
export const LazyPreviewScreen = (props: LazyPreviewScreenProps) => (
  <Suspense fallback={<PreviewLoadingFallback />}>
    <PreviewScreen {...props} />
  </Suspense>
);
